export default __webpack_public_path__ + "static/media/YT-kod.9dbb6550.webp";